import { css } from 'styled-components';

export const InvalidLinkContent = css(({ theme }) => {
  return css`
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100%;
    gap: 20px;

    > .broken-link-icon {
      width: 100px;
      height: 100px;
    }

    > .text {
      text-align: center;
      margin: 0 8px;
      color: ${theme.colors.primaryDeepBlue};
    }

    > .title {
      font-weight: 700;
      font-size: 21px;
      line-height: normal;

      @media only screen and ${theme.device.tablet} {
        font-weight: 600;
        font-size: 25px;
        line-height: 30px;
      }
    }

    > .subtitle {
      font-weight: 500;
      font-size: 18px;
      line-height: 27px;
      white-space: pre-line;
    }
  `;
});
